<template>
    <section class="mt-5 mb-5">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="cmsbanner">
                        <a href="" class="banner-anchor">
                            <img :src="appUrl+'/guest/images/offer-1.jpg'" alt="Banner 1" class="img-fluid">
                        </a>
                        <div class="cmsbanner-text">
                            <div class="offer-title">30% Discount</div>
                            <div class="main-title">Office Work Books</div>
                            <div class="mt-3"><a class="cta-btn" href="">Shop Now</a></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="cmsbanner">
                        <a href="" class="banner-anchor">
                            <img :src="appUrl+'/guest/images/offer-1.jpg'" alt="Banner 2" class="img-fluid">
                        </a>
                        <div class="cmsbanner-text">
                            <div class="offer-title">30% Discount</div>
                            <div class="main-title">Office Work Books</div>
                            <div class="mt-3"><a class="cta-btn" href="">Shop Now</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        computed: {},
        data() {
            return {
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
            };
        },
        mounted() {
            //console.log(this.appUrl);
        },
    };
</script>
